<template>
  <div class="page">
    <c-source-page
      :table="table"
      :columns="columns"
      :filter="filter"
      :pagination="pagination"
    />
  </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';

@Component
export default class GoodsList extends Vue {

  pagination = {}

  filter = [
    {
      prop: 'sku_id_cont',
      label: 'SKU编码',
      form: {
        component: 'input'
      }
    }
  ]

  table = {
    data: []
  };

  columns = [
    {
      prop: 'id',
      label: '编号',
      width: 80,
      action: ['hide-in-detail']
    },
    {
      prop: 'sku_id',
      label: 'SKU编码'
    },
    {
      prop: 'display_name',
      width: 160,
      label: '商品名'
    },
    {
      prop: 'shared_cover',
      label: '图片',
      renderCell: 'image'
    },
    {
      prop: 'sale_price',
      label: '售价(元)'
    },
    {
      prop: 'discount_price',
      label: '折扣价(元)'
    },
    {
      prop: 'employee_price',
      label: '员工价(元)'
    },
    {
      prop: 'commission',
      label: '佣金(元)'
    },
    {
      prop: 'qty',
      label: '库存数量(件)'
    }
  ]

  async mounted() {
    const result = await this.$request.get(`/products/${this.$route.params.id}/goodses`, { params: this.$route.query });
    this.table.data = result.data;
    this.pagination = result.pagination;
  }
}

</script>
